var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MarkdownRenderer: () => MarkdownRenderer,
  MarkdownRendererLifeCycle: () => import_markdown_it_custom_renderer3.CustomRendererLifeCycle,
  MarkdownRendererMode: () => import_markdown_it_custom_renderer3.CustomRendererMode,
  default: () => src_exports,
  mdRenderer: () => mdRenderer
});
module.exports = __toCommonJS(src_exports);

// src/renderer/index.ts
var import_markdown_it_custom_renderer2 = require("@diplodoc/markdown-it-custom-renderer");

// src/rules/inline/softbreak.ts
var softbreak = {
  softbreak: function() {
    return "\n";
  }
};

// src/rules/inline/hardbreak.ts
var hardbreak = {
  hardbreak: function() {
    return "\\\n";
  }
};

// src/rules/inline/text.ts
var text = {
  text: function(tokens, i) {
    return tokens[i].content;
  }
};

// src/rules/inline/basic.ts
var rules = /* @__PURE__ */ new Set([
  "em_open",
  "em_close",
  "strong_open",
  "strong_close",
  "sup_open",
  "sup_close",
  "monospace_open",
  "monospace_close",
  "s_open",
  "s_close"
]);
function basic(tokens, i) {
  const { type, markup } = tokens[i];
  if (rules.has(type)) {
    return markup;
  }
  throw new Error("failed to render emphasis");
}

// src/rules/inline/emphasis.ts
var emphasis = {
  em_open: basic,
  em_close: basic,
  strong_open: basic,
  strong_close: basic
};

// src/rules/inline/code.ts
var code = {
  code_inline: function(tokens, i) {
    const { markup, content } = tokens[i];
    return markup + content + markup;
  }
};

// src/rules/inline/link.ts
var initState = () => ({
  link: {
    pending: new Array()
  }
});
var link = {
  link_open: function(tokens, i) {
    this.state.link.pending.push(tokens[i]);
    return tokens[i].markup === "autolink" ? "<" : "[";
  },
  link_close: function() {
    const token = this.state.link.pending.pop();
    if ((token == null ? void 0 : token.type) !== "link_open") {
      throw new Error("failed to render link token");
    }
    if (token.markup === "autolink") {
      const href2 = token.attrGet("href");
      if (!(href2 == null ? void 0 : href2.length)) {
        throw new Error("failed to render autolink token");
      }
      return ">";
    }
    let rendered = "](";
    const href = token.attrGet("href");
    if (href == null ? void 0 : href.length) {
      rendered += href;
    }
    const title = token.attrGet("title");
    if (title == null ? void 0 : title.length) {
      if (href == null ? void 0 : href.length) {
        rendered += " ";
      }
      const markup = title.indexOf('"') === -1 ? '"' : "'";
      rendered += `${markup}${title}${markup}`;
    }
    rendered += ")";
    return rendered;
  }
};
var link_default = { link, initState };

// src/rules/inline/image.ts
var import_token = __toESM(require("markdown-it/lib/token"));
var initState2 = () => ({
  image: {
    pending: new Array()
  }
});
var image = {
  image: function(tokens, i, options, env) {
    const img = tokens[i];
    this.state.image.pending.push(img);
    const open = new import_token.default("image_open", "", 0);
    const close = new import_token.default("image_close", "", 0);
    const children = img.children ?? [];
    return this.renderInline([open, ...children, close], options, env);
  },
  image_open: function() {
    return "![";
  },
  image_close: function() {
    const token = this.state.image.pending.pop();
    if ((token == null ? void 0 : token.type) !== "image") {
      throw new Error("failed to render image token");
    }
    let rendered = "](";
    const src = token.attrGet("src");
    if (src == null ? void 0 : src.length) {
      rendered += src;
    }
    const title = token.attrGet("title");
    if (title == null ? void 0 : title.length) {
      if (src == null ? void 0 : src.length) {
        rendered += " ";
      }
      const markup = title.indexOf('"') === -1 ? '"' : "'";
      rendered += `${markup}${title}${markup}`;
    }
    rendered += ")";
    return rendered;
  }
};
var image_default = { image, initState: initState2 };

// src/rules/inline/index.ts
var inline = {
  ...code,
  ...link,
  ...image,
  ...emphasis,
  ...text,
  ...softbreak,
  ...hardbreak
};

// src/rules/block/hr.ts
var hr = {
  hr: function(tokens, i) {
    let rendered = "";
    if (i) {
      rendered += this.EOL;
    }
    rendered += tokens[i].markup;
    return rendered;
  }
};

// src/rules/block/paragraph.ts
var interrupters = /* @__PURE__ */ new Set(["hr", "heading_close", "code_block", "fence"]);
var separate = /* @__PURE__ */ new Set([
  "paragraph_close",
  "bullet_list_close",
  "ordered_list_close",
  "html_block",
  "yfm_cut_close",
  "yfm_note_close"
]);
var diplodocBlocks = /* @__PURE__ */ new Set(["yfm_cut_close", "yfm_note_close"]);
var paragraph = {
  paragraph_open: function(tokens, i) {
    const current = tokens[i];
    if (!current) {
      throw new Error("failed to rendrer paragraph");
    }
    let rendered = "";
    if (!i) {
      return rendered;
    }
    const previous = tokens[i - 1];
    if (!previous) {
      throw new Error("failed to rendrer paragraphi");
    }
    if (!previous.block && !diplodocBlocks.has(previous.type)) {
      return "";
    }
    if (previous.type === "yfm_td_open") {
      return this.renderContainer(current);
    } else if (interrupters.has(previous.type)) {
      rendered += this.EOL;
    } else {
      if (previous.type === "blockquote_close") {
        rendered += this.EOL;
      }
      if (separate.has(previous.type)) {
        rendered += this.EOL;
        rendered += this.renderContainer(current);
      }
      rendered += this.EOL;
    }
    rendered += this.renderContainer(current);
    return rendered;
  },
  paragraph_close: function() {
    return "";
  }
};

// src/processors/index.ts
function normalizeSource(source) {
  return source.map((l) => l.replace(/\t/gmu, " ".repeat(4)));
}

// src/token/index.ts
function getMap(token) {
  const [start, end] = token.map ?? [null, null];
  if (start == null || end == null) {
    throw new Error("token doesn't have row map, unable to render");
  }
  return [start, end];
}

// src/rules/block/heading.ts
var initState3 = () => ({
  heading: {
    pending: new Array()
  }
});
var heading = {
  heading_open: function(tokens, i) {
    const { markup } = tokens[i];
    let rendered = "";
    if (i) {
      rendered += this.EOL;
    }
    rendered += this.renderContainer(tokens[i]);
    if (!isSetexHeading(tokens[i])) {
      rendered += markup + this.SPACE;
      return rendered;
    }
    this.state.heading.pending.push(tokens[i]);
    const previous = tokens[i - 1];
    if ((previous == null ? void 0 : previous.type) === "paragraph_close") {
      rendered += this.EOL;
    }
    return rendered;
  },
  heading_close: function(...args) {
    const {
      3: { source }
    } = args;
    const open = this.state.heading.pending.pop();
    if (!open || !(source == null ? void 0 : source.length)) {
      return "";
    }
    const [_, end] = getMap(open);
    return this.EOL + normalizeSource(source)[end - 1];
  }
};
function isSetexHeading(token) {
  const { markup } = token;
  return markup.indexOf("=") !== -1 || markup.indexOf("-") !== -1;
}
var heading_default = { heading, initState: initState3 };

// src/rules/block/code.ts
var separate2 = /* @__PURE__ */ new Set(["html_block", "paragraph_close", "bullet_list_close"]);
var code2 = {
  code_block: function(tokens, i, options, env) {
    let rendered = "";
    if (i) {
      const previous = tokens[i - 1];
      const height = separate2.has(previous == null ? void 0 : previous.type) ? 2 : 1;
      rendered += this.EOL.repeat(height);
    }
    let indentation = 0;
    const [start, end] = getMap(tokens[i]);
    const { source } = env;
    if (source) {
      const [first] = normalizeSource(source).slice(start, end);
      const spaces = first.length - first.trimStart().length;
      indentation += spaces > 4 ? 4 : spaces;
    } else {
      indentation += 4;
    }
    const contentLines = tokens[i].content.split("\n");
    if (this.containers.length) {
      for (const line of contentLines) {
        if (line.length) {
          rendered += this.renderContainer(tokens[i]);
        }
        rendered += line;
        rendered += this.EOL;
      }
    } else {
      for (const line of contentLines) {
        if (line.length) {
          rendered += this.SPACE.repeat(indentation);
        }
        rendered += line;
        rendered += this.EOL;
      }
    }
    rendered = rendered.trimEnd();
    return rendered;
  }
};
function isCode(token) {
  return token.type === "code_block";
}

// src/parsers/index.ts
function skipChars(str, chars, start = 0) {
  const checkCharsInLine = charsCheck(str);
  const len = str.length;
  let i = start;
  let checker = checkCharsInLine(i);
  while (chars.some(checker) && i < len) {
    i++;
    checker = checkCharsInLine(i);
  }
  return i;
}
function charsCheck(str) {
  return (i) => (ch) => str.charAt(i) === ch;
}

// src/rules/block/fence.ts
var fence = {
  fence: fenceHandler
};
function fenceHandler(tokens, i, options, env) {
  var _a, _b;
  const { markup, info, content } = tokens[i];
  let rendered = "";
  if (i) {
    const previous = tokens[i - 1];
    const height = (previous == null ? void 0 : previous.type) === "html_block" ? 2 : 1;
    rendered += this.EOL.repeat(height);
  }
  let openMarkup = markup;
  let openIndent = 0;
  let closeMarkup = markup;
  let closeIndent = 0;
  let contentLines = (content == null ? void 0 : content.length) ? content.split("\n") : [];
  const [start, end] = getMap(tokens[i]);
  const { source } = env;
  if (end > start && (source == null ? void 0 : source.length)) {
    const fenceLength = end - start;
    const fenceLines = normalizeSource(source).slice(start, end);
    let firstLine, lastLine;
    firstLine = lastLine = fenceLines[0];
    if (fenceLength > 1) {
      firstLine = fenceLines[0];
      lastLine = fenceLines[fenceLines.length - 1];
    }
    if ((content == null ? void 0 : content.length) && fenceLength === 2) {
      contentLines = fenceLines.slice(1);
    } else {
      contentLines = fenceLines.slice(1, fenceLines.length - 1);
    }
    const firstTokens = parseFence(firstLine);
    if (((_a = firstTokens == null ? void 0 : firstTokens.markup) == null ? void 0 : _a.length) && firstTokens.indentation !== null) {
      openMarkup = firstTokens.markup;
      openIndent = firstTokens.indentation;
    }
    const lastTokens = parseFence(lastLine);
    if (((_b = lastTokens == null ? void 0 : lastTokens.markup) == null ? void 0 : _b.length) && lastTokens.indentation !== null) {
      closeMarkup = lastTokens.markup;
      closeIndent = lastTokens.indentation;
    }
  }
  if (this.containers.length) {
    rendered += this.renderContainer(tokens[i]);
    rendered += openMarkup;
    if (info == null ? void 0 : info.length) {
      rendered += info;
    }
    rendered += this.EOL;
    for (const line of contentLines) {
      rendered += line;
      rendered += this.EOL;
    }
    rendered += this.renderContainer(tokens[i]);
    rendered += closeMarkup;
  } else {
    rendered += this.SPACE.repeat(openIndent);
    rendered += openMarkup;
    if (info == null ? void 0 : info.length) {
      rendered += info;
    }
    rendered += this.EOL;
    for (const line of contentLines) {
      rendered += line;
      rendered += this.EOL;
    }
    rendered += this.SPACE.repeat(closeIndent);
    rendered += closeMarkup;
  }
  return rendered;
}
function parseFence(str) {
  let i;
  let indentation = 0;
  i = skipChars(str, [" "]);
  indentation = i;
  let syntax = "";
  for (i = 0; i < str.length; i++) {
    const char = str.charAt(i);
    if (char === "`" || char === "~") {
      syntax = char;
      break;
    }
  }
  if (!(syntax == null ? void 0 : syntax.length)) {
    return { succ: false };
  }
  const markupStart = i;
  i = skipChars(str, [syntax], i);
  const markupEnd = i;
  const markup = str.slice(markupStart, markupEnd);
  const tail = str.slice(i + 1);
  return { indentation, markup, tail };
}

// src/rules/block/html.ts
var html = {
  html_block: function(tokens, i) {
    const { content } = tokens[i];
    let rendered = "";
    if (i) {
      const previous = tokens[i - 1];
      if ((previous == null ? void 0 : previous.type) === "fence" || (previous == null ? void 0 : previous.type) === "code_block" || (previous == null ? void 0 : previous.type) === "html_block" || (previous == null ? void 0 : previous.type) === "paragraph_close" || this.containers.length) {
        rendered += this.EOL.repeat(2);
      } else {
        rendered += this.EOL;
      }
    }
    for (const line of content.trimEnd().split("\n")) {
      rendered += this.renderContainer(tokens[i]) + line + this.EOL;
    }
    rendered = rendered.trimEnd();
    return rendered;
  }
};

// src/rules/block/containers/index.ts
function isTail(container, ctx) {
  const [start] = getMap(ctx);
  return start >= container.row && container.rendered;
}
function isFst(container, ctx) {
  const [start] = getMap(ctx);
  return !container.rendered && (container.row === start || isBlockquote(container));
}
function isEmpty(container) {
  return container.empty;
}
function sameRow(left, right) {
  return left.row === right.row;
}
function aligned(left, right) {
  return left.col + left.tspaces + left.markup.length >= right.col - right.lspaces;
}

// src/rules/diplodoc/gfm-tables.ts
var always = (a) => () => a;
var alwaysEmptyStr = always("");
var initState4 = () => ({
  gfmTables: {
    pending: new Array()
  }
});
var gfmTables = {
  table_open: function(tokens, i) {
    let rendered = "";
    const insideNonListContainer = this.containers.length && tokens[i - 1].type !== "list_item_open";
    if (i && !this.containers.length || insideNonListContainer) {
      rendered += this.EOL;
    }
    return rendered;
  },
  thead_open: function(tokens, i) {
    const rendered = "";
    this.state.gfmTables.pending.push(tokens[i]);
    return rendered;
  },
  tr_open: function(tokens, i) {
    let rendered = "";
    rendered += this.renderContainer(tokens[i]);
    return rendered;
  },
  tr_close: function() {
    return this.EOL;
  },
  th_open: always("|"),
  th_close: function(tokens, i) {
    let rendered = "";
    if (i + 1 === tokens.length || tokens[i + 1].type !== "th_open") {
      rendered += "|";
    }
    return rendered;
  },
  thead_close: function(tokens, i, options, env) {
    let rendered = "";
    const theader = this.state.gfmTables.pending.pop();
    if (!(theader == null ? void 0 : theader.map)) {
      throw new Error("failed to render GFM Table, no map found for the table open");
    }
    const { source } = env;
    if (!(source == null ? void 0 : source.length)) {
      throw new Error("failed to render GFM Table, pass markdown source as an environment");
    }
    const [_, end] = theader.map;
    const format = normalizeSource(source)[end];
    if (!format.length) {
      throw new Error("failed to render GFM Table, header formatting not found");
    }
    rendered += format;
    rendered += this.EOL;
    return rendered;
  },
  tbody_open: alwaysEmptyStr,
  tbody_close: alwaysEmptyStr,
  td_open: always("|"),
  td_close: function(tokens, i) {
    let rendered = "";
    if (i + 1 === tokens.length || tokens[i + 1].type !== "td_open") {
      rendered += "|";
    }
    return rendered;
  },
  table_close: alwaysEmptyStr
};
function isTableRowOpen(token) {
  return token.type === "tr_open";
}
var gfm_tables_default = { gfmTables, initState: initState4, isTableRowOpen };

// src/rules/block/list.ts
var initState5 = () => ({
  list: {
    context: new Array(),
    last: new Array()
  }
});
var list = {
  bullet_list_open: listOpen,
  bullet_list_close: listClose,
  ordered_list_open: listOpen,
  ordered_list_close: listClose,
  list_item_open: listItemOpen,
  list_item_close: listItemClose
};
function listOpen(tokens, i) {
  const type = tokens[i].type;
  this.state.list.context.push(type);
  return "";
}
function listClose() {
  this.state.list.context.pop();
  return "";
}
function listItemOpen(tokens, i, options, env) {
  const { source } = env;
  const { markup } = tokens[i];
  if (!(source == null ? void 0 : source.length) || !markup) {
    throw new Error("failed to render ordered list");
  }
  const [start] = getMap(tokens[i]);
  const [line] = normalizeSource(source).slice(start, start + 1);
  if (!(line == null ? void 0 : line.length)) {
    throw new Error("failed to render ordered list");
  }
  let j = 0;
  for (const container of this.containers) {
    if (isBlockquote(container)) {
      j = consumeBlockquote(line, j, container);
    } else if (isList(container)) {
      if (container.row === start) {
        j = consumeList(line, j, container);
      } else {
        j = container.col + container.markup.length + container.tspaces;
      }
    }
  }
  let lspaces = j;
  j = skipChars(line, [" "], j);
  lspaces = lspaces === j ? 0 : j - lspaces;
  const col = line.indexOf(markup, j);
  if (col === -1) {
    throw new Error("failed to render list");
  }
  j = skipChars(line, [" "], col + 1);
  let tspaces = j - col - 1;
  const listCtxLen = this.state.list.context.length;
  const listType = this.state.list.context[listCtxLen - 1];
  let empty = line.slice(col).trimEnd().endsWith(markup);
  const k = skipChars(line, [" ", "\n"], col + 1);
  if (k !== line.length) {
    empty = false;
  }
  if (empty) {
    let [next] = normalizeSource(source).slice(start + 1, start + 2);
    if (!(next == null ? void 0 : next.length)) {
      next = "";
    }
    j = skipChars(next, [" "]);
    tspaces = j;
  }
  const parsed = {
    rendered: false,
    type: listType,
    row: start,
    col,
    lspaces,
    tspaces,
    markup,
    empty
  };
  if (isOrderedList(parsed)) {
    const match = line.match(/(\d+)(?:\.|\)\s+|$)/);
    if (!match || match.index == null || match[1] == null) {
      throw new Error("failed to render list");
    }
    const order = parseInt(match[1], 10);
    if (isNaN(order) || match.index >= col) {
      throw new Error("failed to render list");
    }
    parsed.order = order;
  }
  this.containers.push(parsed);
  return "";
}
function consumeList(line, i, container) {
  const cursor = i;
  const col = line.indexOf(container.markup, cursor);
  if (col === -1) {
    throw new Error("failed to render list");
  }
  return col;
}
function isList(token) {
  return isOrderedList(token) || isUnorderedList(token);
}
function isOrderedList(token) {
  return (token == null ? void 0 : token.type) === "ordered_list_open";
}
function isUnorderedList(token) {
  return (token == null ? void 0 : token.type) === "bullet_list_open";
}
function isListItemClose(token) {
  return (token == null ? void 0 : token.type) === "list_item_close";
}
function isOrderedListClose(token) {
  return (token == null ? void 0 : token.type) === "ordered_list_close";
}
function isUnorderedListClose(token) {
  return (token == null ? void 0 : token.type) === "bullet_list_close";
}
function listItemClose(tokens, i) {
  let rendered = "";
  const containersLen = this.containers.length;
  if (containersLen && !this.containers[containersLen - 1].rendered) {
    rendered += this.renderContainer(tokens[i]);
  }
  this.containers.pop();
  if (tokens[i - 1]) {
    this.state.list.last.push(tokens[i - 1]);
  }
  return rendered;
}
function renderEmptyListItem(containers, i, caller) {
  const container = containers[i];
  let rendered = "";
  if (isListItemClose(caller) && !container.rendered) {
    if (isOrderedList(container) && isContainerOrderedList(container)) {
      rendered += this.EOL;
      rendered += container.order;
      rendered += container.markup;
    } else if (isUnorderedList(container)) {
      rendered += this.EOL;
      rendered += container.markup;
    } else {
      throw new Error("empty list not ordered and not unordered");
    }
  }
  return rendered;
}
function renderOrderedList(containers, i, caller) {
  const container = containers[i];
  let rendered = "";
  const empty = isListItemClose(caller) && !container.rendered;
  if (isOrderedList(container) && !empty && isContainerOrderedList(container)) {
    if (isFst(container, caller) && !isEmpty(container)) {
      let codeIndent = 0;
      if (isCode(caller) && !isEmpty(container)) {
        const codeFstLine = caller.content.split("\n")[0] ?? "";
        codeIndent = codeFstLine.length - codeFstLine.trim().length;
      }
      if (isTableRowOpen(caller)) {
        const last = this.state.list.last.pop();
        if ((last == null ? void 0 : last.type) === "paragraph_close") {
          rendered += this.EOL;
        }
      }
      rendered += container.order;
      rendered += container.markup;
      rendered += this.SPACE.repeat(container.tspaces - codeIndent);
      if (isCode(caller) && !isEmpty(container)) {
        this.containers[i].tspaces = this.containers[i].tspaces - 4 - codeIndent;
      }
    } else if (isTail(container, caller)) {
      let indentation = 0;
      const orderLen = `${container.order}`.length;
      if (!isEmpty(container)) {
        indentation += orderLen;
        indentation += container.markup.length;
      }
      indentation += container.tspaces;
      if (isCode(caller)) {
        indentation += 4;
      }
      rendered += this.SPACE.repeat(indentation);
    } else if (isEmpty(container) && !container.rendered) {
      rendered += container.order;
      rendered += container.markup;
      rendered += this.EOL;
      let indentation = 0;
      indentation += container.tspaces;
      rendered += this.SPACE.repeat(indentation);
    } else {
      throw new Error("ordered list not fst not tail - undefined behaviour");
    }
  }
  return rendered;
}
function renderUnorderedList(containers, i, caller) {
  const container = containers[i];
  let rendered = "";
  const empty = isListItemClose(caller) && !container.rendered;
  if (isUnorderedList(container) && !empty) {
    if (isFst(container, caller) && !isEmpty(container)) {
      if (isTableRowOpen(caller)) {
        const last = this.state.list.last.pop();
        if ((last == null ? void 0 : last.type) === "paragraph_close") {
          rendered += this.EOL;
        }
      }
      rendered += container.markup;
      rendered += this.SPACE.repeat(container.tspaces);
    } else if (isTail(container, caller)) {
      let indentation = 0;
      if (!isEmpty(container)) {
        indentation += container.markup.length;
      }
      if (isCode(caller)) {
        indentation += 4;
      }
      indentation += container.tspaces;
      rendered += this.SPACE.repeat(indentation);
    } else if (isEmpty(container) && !container.rendered) {
      rendered += container.markup;
      rendered += this.EOL;
      let indentation = 0;
      indentation += container.tspaces;
      rendered += this.SPACE.repeat(indentation);
    } else {
      throw new Error("unordered list not fst not tail - undefined behaviour");
    }
  }
  return rendered;
}
function isContainerOrderedList(container) {
  return container.order !== void 0;
}
var list_default = {
  list,
  initState: initState5,
  consumeList,
  isList,
  isOrderedList,
  isOrderedListClose,
  isUnorderedList,
  isUnorderedListClose,
  isListItemClose,
  isContainerOrderedList,
  renderEmptyListItem,
  renderUnorderedList,
  renderOrderedList
};

// src/rules/block/blockquote.ts
var blockquote = {
  blockquote_open: function(tokens, i, options, env) {
    const { source } = env;
    const { markup } = tokens[i];
    if (!(source == null ? void 0 : source.length) || !markup) {
      throw new Error("failed to render blockquote");
    }
    const [start] = getMap(tokens[i]);
    const [line] = normalizeSource(source).slice(start, start + 1);
    if (!(line == null ? void 0 : line.length)) {
      throw new Error("failed to render blockquote");
    }
    let j = 0;
    for (const container of this.containers) {
      if (isList(container) && container.row === start) {
        j = consumeList(line, j, container);
        continue;
      }
      if (isBlockquote(container) && container.row === start) {
        j = consumeBlockquote(line, j, container);
      }
    }
    if (this.containers.length === 1) {
      j = 0;
    }
    const col = line.indexOf(markup, j);
    if (col === -1) {
      throw new Error("failed to render blockquote");
    }
    j = skipChars(line, [" "], col + 1);
    this.containers.push({
      type: tokens[i].type,
      lspaces: 0,
      tspaces: j - col - 1,
      row: start,
      col,
      markup,
      rendered: false
    });
    return i && isBlockquoteClose(tokens[i - 1]) ? this.EOL : "";
  },
  blockquote_close: function(tokens, i) {
    let rendered = "";
    const containersLen = this.containers.length;
    if (containersLen && !this.containers[containersLen - 1].rendered) {
      rendered += this.renderContainer(tokens[i]);
    }
    this.containers.pop();
    return rendered;
  }
};
function consumeBlockquote(line, i, container) {
  let cursor = i ?? 0;
  const index = line.indexOf(container.markup, cursor);
  if (index === -1) {
    throw new Error("failed to spin");
  }
  cursor = index + 1;
  return cursor;
}
function isBlockquote(token) {
  return token.type === "blockquote_open";
}
function isBlockquoteClose(token) {
  return token.type === "blockquote_close";
}
function renderEmptyBlockquote(containers, i, caller) {
  const container = containers[i];
  let rendered = "";
  if (isBlockquoteClose(caller) && !container.rendered) {
    rendered += this.EOL;
    rendered += container.markup;
  }
  return rendered;
}
function renderBlockquote(containers, i, caller) {
  const container = containers[i];
  let rendered = "";
  const empty = isBlockquoteClose(caller) && !container.rendered;
  if (isBlockquote(container) && !empty) {
    if (isFst(container, caller)) {
      rendered += container.markup;
      rendered += this.SPACE.repeat(container.tspaces);
    } else if (isTail(container, caller)) {
      rendered += container.markup;
      rendered += this.SPACE.repeat(container.tspaces);
    } else if (isEmpty(container) && !container.rendered) {
      rendered += container.markup;
      rendered += this.EOL;
    } else {
      throw new Error("blockquote not fast not tail - undefined behaviour");
    }
  }
  return rendered;
}

// src/rules/block/index.ts
var block = {
  ...paragraph,
  ...heading,
  ...hr,
  ...code2,
  ...fence,
  ...html,
  ...blockquote,
  ...list
};

// src/rules/diplodoc/notes.ts
var notes = {
  yfm_note_open: function(tokens, i) {
    const token = tokens[i];
    let rendered = "";
    if (i) {
      rendered += this.EOL;
    }
    rendered += this.EOL;
    rendered += this.renderContainer(token);
    const type = token.attrGet("note-type");
    if (!(type == null ? void 0 : type.length)) {
      throw new Error("failed to render note, reason: couldn't find note type");
    }
    rendered += `{% note ${type} `;
    return rendered;
  },
  yfm_note_title_open: function() {
    return '"';
  },
  yfm_note_title_close: function() {
    let rendered = '" %}';
    rendered += this.EOL;
    return rendered;
  },
  yfm_note_close: function(tokens, i) {
    let rendered = "";
    rendered += this.EOL.repeat(2);
    const token = tokens[i];
    rendered += this.renderContainer(token);
    rendered += "{% endnote %}";
    return rendered;
  }
};

// src/rules/diplodoc/cuts.ts
var cuts = {
  yfm_cut_open: function(tokens, i) {
    let rendered = "";
    if (i) {
      rendered += this.EOL;
    }
    if (!this.containers.length) {
      rendered += this.EOL;
    }
    if (this.containers.length && i && tokens[i - 1].type !== "list_item_open") {
      rendered += this.EOL;
    }
    rendered += this.renderContainer(tokens[i]);
    rendered += "{% cut ";
    return rendered;
  },
  yfm_cut_title_open: function() {
    return '"';
  },
  yfm_cut_title_close: function() {
    let rendered = '" %}';
    rendered += this.EOL;
    return rendered;
  },
  yfm_cut_content_open: function(tokens, i) {
    let rendered = "";
    rendered += this.EOL;
    rendered += this.renderContainer(tokens[i]);
    return rendered;
  },
  yfm_cut_content_close: function() {
    return this.EOL;
  },
  yfm_cut_close: function(tokens, i) {
    let rendered = "";
    rendered += this.EOL;
    rendered += this.renderContainer(tokens[i]);
    rendered += "{% endcut %}";
    return rendered;
  }
};

// src/rules/diplodoc/sup.ts
var sup = {
  sup_open: basic,
  sup_close: basic
};

// src/rules/diplodoc/monospace.ts
var monospace = {
  monospace_open: basic,
  monospace_close: basic
};

// src/rules/diplodoc/checkbox.ts
var always2 = (v) => () => v;
var alwaysEmpty = always2("");
var checkbox = {
  checkbox_open: function(tokens, i) {
    let rendered = "";
    if (i > 2 && tokens[i - 3].type !== "checkbox_close") {
      rendered += this.EOL;
    }
    rendered += this.renderContainer(tokens[i]);
    rendered += "[";
    return rendered;
  },
  checkbox_input: function(tokens, i, options, env) {
    const current = tokens[i];
    let rendered = "";
    const [row] = current.map ?? [];
    if (row == null) {
      throw new Error("missing line mapping on token");
    }
    let fallback = false;
    let syntax;
    if (env.source) {
      ({ syntax, fallback } = parseCheckboxSyntax(env.source, row));
    }
    if (!env.source || fallback) {
      const checked = current.attrGet("checked");
      syntax = checked === "true" ? "x" : this.SPACE;
    }
    rendered += `${syntax}] `;
    return rendered;
  },
  checkbox_label_open: alwaysEmpty,
  checkbox_label_close: alwaysEmpty,
  checkbox_close: function(tokens, i) {
    let rendered = "";
    if (isLastCheckboxInList(this.containers, tokens, i)) {
      return rendered;
    }
    rendered += this.EOL;
    return rendered;
  }
};
function parseCheckboxSyntax(source, row) {
  const line = normalizeSource(source)[row];
  const match = line.match(/\[(x|\s|_|-)\]/i);
  if (match == null ? void 0 : match.index) {
    const syntax = line.slice(match.index + 1, match.index + 2);
    return { syntax, fallback: false };
  }
  return { syntax: "", fallback: true };
}
function isLastCheckboxInList(containers, tokens, i) {
  const listClose2 = tokens[i + 2];
  const listItemClose2 = tokens[i + 1];
  return containers.length && listItemClose2 && isListItemClose(listItemClose2) && listClose2 && (isUnorderedListClose(listClose2) || isOrderedListClose(listClose2));
}

// src/rules/diplodoc/imsize.ts
var imsize = {
  image_close: function() {
    const token = this.state.image.pending.pop();
    if ((token == null ? void 0 : token.type) !== "image") {
      throw new Error("failed to render image token");
    }
    let rendered = "](";
    const src = token.attrGet("src");
    if (src == null ? void 0 : src.length) {
      rendered += src;
    }
    const title = token.attrGet("title");
    if (title == null ? void 0 : title.length) {
      if (src == null ? void 0 : src.length) {
        rendered += " ";
      }
      const markup = title.indexOf('"') === -1 ? '"' : "'";
      rendered += `${markup}${title}${markup}`;
    }
    const width = token.attrGet("width");
    const height = token.attrGet("height");
    if (((width == null ? void 0 : width.length) || (height == null ? void 0 : height.length)) && ((src == null ? void 0 : src.length) || (title == null ? void 0 : title.length))) {
      rendered += this.SPACE;
    }
    if ((width == null ? void 0 : width.length) || (height == null ? void 0 : height.length)) {
      rendered += "=";
    }
    if (width == null ? void 0 : width.length) {
      rendered += width;
    }
    if ((width == null ? void 0 : width.length) || (height == null ? void 0 : height.length)) {
      rendered += "x";
    }
    if (height == null ? void 0 : height.length) {
      rendered += height;
    }
    rendered += ")";
    return rendered;
  }
};

// src/rules/diplodoc/file.ts
var PREFIX = "{% file ";
var ATTRS_MAPPING = /* @__PURE__ */ new Map([
  ["href", "src"],
  ["download", "name"],
  ["hreflang", "lang"],
  ["type", "type"],
  ["target", "target"],
  ["rel", "rel"],
  ["referrerpolicy", "referrerpolicy"]
]);
function yfmFile(tokens, i) {
  let rendered = "";
  const attrs = tokens[i].attrs || [];
  rendered += PREFIX;
  for (const [key, value] of attrs) {
    if (ATTRS_MAPPING.has(key)) {
      const attr = ATTRS_MAPPING.get(key);
      rendered += `${attr}="${value}" `;
    }
  }
  rendered += "%}";
  return rendered;
}
var file = {
  yfm_file: yfmFile
};

// src/rules/diplodoc/strikethrough.ts
var strikethrough = {
  s_open: basic,
  s_close: basic
};

// src/rules/diplodoc/tabs.ts
var tabs = {
  tabs_open: function(tokens, i) {
    let rendered = "";
    if (i) {
      rendered += this.EOL.repeat(2);
    }
    rendered += "{% list tabs %}" + this.EOL;
    return rendered;
  },
  // tab content open
  "tab-panel_open": function() {
    return "\n";
  },
  // tab content close
  "tab-panel_close": function() {
    return "";
  },
  tabs_close: function() {
    let rendered = "";
    rendered += this.EOL.repeat(2);
    rendered += "{% endlist %}";
    rendered += this.EOL;
    return rendered;
  }
};

// src/rules/diplodoc/video.ts
var video = {
  video: function(tokens, i) {
    const { service, videoID } = tokens[i];
    let rendered = `@[${service}](${videoID})`;
    if (i + 1 === tokens.length) {
      return rendered;
    }
    const next = tokens[i + 1];
    if (next.type === "text") {
      rendered += this.SPACE;
    }
    return rendered;
  }
};

// src/rules/diplodoc/multiline-tables.ts
var always3 = (a) => () => a;
var alwaysEmptyStr2 = always3("");
var cellOpenInterrupters = /* @__PURE__ */ new Set(["yfm_td_close", "bullet_list_open", "ordered_list_open"]);
var multilineTables = {
  yfm_tbody_open: alwaysEmptyStr2,
  yfm_tbody_close: alwaysEmptyStr2,
  yfm_table_open: function(tokens, i) {
    let rendered = "";
    if (i && tokens[i - 1].type !== "yfm_td_open") {
      rendered += this.EOL.repeat(2);
    }
    rendered += this.renderContainer(tokens[i]);
    rendered += "#|";
    return rendered;
  },
  yfm_table_close: function(tokens, i) {
    let rendered = "";
    rendered += this.renderContainer(tokens[i]);
    rendered += "|#";
    const next = tokens[i + 1];
    const nextnext = tokens[i + 2];
    const shouldntSeparate = (nextnext == null ? void 0 : nextnext.type) === "bullet_list_close" || (nextnext == null ? void 0 : nextnext.type) === "ordered_list_close" || (next == null ? void 0 : next.type) === "yfm_td_close";
    if (!shouldntSeparate) {
      rendered += this.EOL;
    }
    return rendered;
  },
  yfm_tr_open: function(tokens, i) {
    let rendered = "";
    if (tokens[i - 1].type !== "yfm_tr_close") {
      rendered += "\n";
    }
    rendered += this.renderContainer(tokens[i]);
    rendered += "|";
    return rendered;
  },
  yfm_tr_close: function() {
    return "|\n";
  },
  yfm_td_open: function(tokens, i) {
    let rendered = "|";
    const next = tokens[i + 1];
    if (!next) {
      return rendered;
    }
    if (!cellOpenInterrupters.has(next.type)) {
      rendered += "\n";
    }
    return rendered;
  },
  yfm_td_close: function(tokens, i) {
    let rendered = "";
    if (tokens[i - 1].type !== "yfm_td_open") {
      rendered += "\n";
    }
    rendered += this.renderContainer(tokens[i]);
    if (i + 1 !== tokens.length && tokens[i + 1].type !== "yfm_td_open") {
      rendered += "|";
    }
    return rendered;
  }
};

// src/rules/diplodoc/term.ts
var initState6 = () => ({
  term: {
    pending: [],
    didRenderEOL: false
  }
});
var always4 = (value) => () => value;
var term = {
  term_open: function(tokens, i) {
    var _a;
    const key = (_a = tokens[i].attrGet("term-key")) == null ? void 0 : _a.slice(1);
    if (!key) {
      throw new Error("Unable to parse terms: key is not defined");
    }
    this.state.term.pending.push(key);
    this.state.term.didRenderEOL = false;
    return "[";
  },
  term_close: function() {
    let rendered = "]";
    const key = this.state.term.pending.pop();
    rendered += `(*${key})`;
    return rendered;
  },
  template_open: function(tokens, i) {
    const key = tokens[i].attrGet("label");
    const rendered = this.EOL.repeat(i ? 2 : 1) + `[*${key}]: `;
    return rendered;
  },
  template_close: function(tokens, i) {
    const next = tokens[i + 1];
    const isLast = i === tokens.length - 1;
    if (!isLast && (!this.state.term.didRenderEOL || shouldSeparate(next))) {
      return this.EOL;
    }
    return "";
  },
  dfn_close: function(tokens, i) {
    const previous = tokens[i - 1];
    const isLast = i === tokens.length - 2;
    if (!isLast && shouldSeparate(previous)) {
      this.state.term.didRenderEOL = true;
      return this.EOL;
    }
    return "";
  },
  dfn_open: always4("")
};
var SEPARATED_TOKENS = /* @__PURE__ */ new Set([
  /** last token in term definition */
  "bullet_list_close",
  "ordered_list_close",
  /** token after term definition */
  "bullet_list_open",
  "ordered_list_open",
  "blockquote_open"
]);
function shouldSeparate(token) {
  if (!token) {
    return true;
  }
  if (SEPARATED_TOKENS.has(token.type)) {
    return false;
  }
  return true;
}
var term_default = { term, initState: initState6 };

// src/rules/diplodoc/index.ts
var diplodoc = {
  ...notes,
  ...cuts,
  ...gfmTables,
  ...sup,
  ...monospace,
  ...checkbox,
  ...imsize,
  ...file,
  ...strikethrough,
  ...tabs,
  ...video,
  ...multilineTables,
  ...term
};

// src/handlers/diplodoc/anchors.ts
var import_token8 = __toESM(require("markdown-it/lib/token"));
var anchors = {
  heading_open: function(tokens, i, options, env) {
    const { source } = env;
    if (!(source == null ? void 0 : source.length)) {
      throw new Error(
        "failed to render anchors, provide split by new line source as environment"
      );
    }
    const next = tokens[i + 1];
    if (next.type !== "inline") {
      return "";
    }
    if (!next.children) {
      next.children = [];
    }
    const anchorLinkStartIdx = next.children.findIndex(({ type }) => type === "link_open");
    const anchorLinkEndtIdx = next.children.findIndex(({ type }) => type === "link_close");
    if (anchorLinkEndtIdx !== -1 && anchorLinkStartIdx !== -1) {
      next.children.splice(anchorLinkStartIdx, anchorLinkEndtIdx - anchorLinkStartIdx + 1);
    }
    const [row] = tokens[i].map ?? [];
    if (row == null) {
      throw new Error("failed to render anchor, no line mapping on header");
    }
    const line = normalizeSource(source)[row];
    if (!(line == null ? void 0 : line.length)) {
      throw new Error("failed to render anchor, incorrect source or line mapping");
    }
    const anchor = normalizeSource(source)[row].match(/\{#([^{]+)\}/gimu);
    if (!(anchor == null ? void 0 : anchor.length)) {
      return "";
    }
    const anchorToken = new import_token8.default("text", "", 0);
    anchorToken.content = ` ${anchor[anchor.length - 1]}`;
    next.children.push(anchorToken);
    return "";
  }
};

// src/handlers/diplodoc/index.ts
var diplodoc2 = {
  ...anchors
};

// src/hooks/diplodoc/index.ts
var import_markdown_it_custom_renderer = require("@diplodoc/markdown-it-custom-renderer");

// src/hooks/diplodoc/reorderTabs.ts
var import_token9 = __toESM(require("markdown-it/lib/token"));
function reorderTabs(parameters) {
  let start;
  let end;
  let shift = 0;
  const contents = [];
  const indexes = [];
  const shifts = [];
  for (let i = 0; i < parameters.tokens.length; i++) {
    const { type } = parameters.tokens[i];
    if (type === "tab_close") {
      indexes.push(i);
      continue;
    }
    if (type === "tab-panel_open") {
      start = i;
      continue;
    }
    if (type === "tab-panel_close") {
      end = i;
    }
    if (start == null || end == null) {
      continue;
    }
    const content = [];
    for (let j = start; j < end + 1; j++) {
      content.push(parameters.tokens[j]);
      parameters.tokens[j] = new import_token9.default("markdown-renderer-trash", "", 0);
      parameters.tokens[j].content = "";
    }
    start = null;
    end = null;
    contents.push(content);
    shift += content.length;
    shifts.push(shift);
  }
  for (let i = 0; i < contents.length; i++) {
    const index = indexes[i] + (shifts[i - 1] ?? 0);
    parameters.tokens.splice(index, 0, ...contents[i]);
  }
  for (let i = 0; i < parameters.tokens.length; i++) {
    const token = parameters.tokens[i];
    if (token.type === "tab-list_close") {
      start = i + 1;
      continue;
    }
    if (token.type === "tabs_close") {
      end = i;
    }
    if (start == null || end == null) {
      continue;
    }
    parameters.tokens.splice(start, end - start);
    i = i - (end - start);
    start = end = null;
  }
  return "";
}

// src/hooks/diplodoc/mapTabsIntoUnorderedLists.ts
var import_token10 = __toESM(require("markdown-it/lib/token"));
function mapTabsIntoUnorderedLists(parameters) {
  for (let i = 0; i < parameters.tokens.length; i++) {
    const token = parameters.tokens[i];
    if (token.type === "tab-list_open") {
      parameters.tokens[i].type = "bullet_list_open";
      parameters.tokens[i].markup = "-";
      continue;
    }
    if (token.type === "tab-list_close") {
      parameters.tokens[i].type = "bullet_list_close";
      continue;
    }
    if (token.type === "tab_open") {
      parameters.tokens[i].type = "list_item_open";
      const paragraphOpen = new import_token10.default("paragraph_open", "", 0);
      const paragraphClose = new import_token10.default("paragraph_close", "", 0);
      paragraphOpen.map = parameters.tokens[i].map;
      const wrappedInline = [paragraphOpen, parameters.tokens[i + 1], paragraphClose];
      parameters.tokens.splice(i + 1, 1, ...wrappedInline);
      continue;
    }
    if (token.type === "tab_close") {
      parameters.tokens[i].type = "list_item_close";
      continue;
    }
  }
  return "";
}

// src/hooks/diplodoc/index.ts
var diplodoc3 = {
  [import_markdown_it_custom_renderer.CustomRendererLifeCycle.BeforeRender]: [reorderTabs, mapTabsIntoUnorderedLists]
};

// src/renderer/constants.ts
var NEW_LINE = "\n";
var ONE_SPACE = " ";

// src/renderer/index.ts
var import_markdown_it_custom_renderer3 = require("@diplodoc/markdown-it-custom-renderer");
var initRulesState = () => ({
  ...heading_default.initState(),
  ...image_default.initState(),
  ...link_default.initState(),
  ...list_default.initState(),
  ...gfm_tables_default.initState(),
  ...term_default.initState()
});
var _MarkdownRenderer = class extends import_markdown_it_custom_renderer2.CustomRenderer {
  constructor(params = {}) {
    const {
      constants: { EOL = NEW_LINE, SPACE = ONE_SPACE } = {},
      containerRenderers = [],
      initState: initState7 = () => ({}),
      rules: rules2,
      handlers,
      hooks
    } = params;
    super({
      ...params,
      handlers: { ..._MarkdownRenderer.defaultHandlers, ...handlers },
      rules: { ..._MarkdownRenderer.defaultRules, ...rules2 },
      initState: () => ({ ...initState7(), ...initRulesState() }),
      hooks: { ..._MarkdownRenderer.defaultHooks, ...hooks }
    });
    this.EOL = EOL;
    this.SPACE = SPACE;
    this.containers = new Array();
    this.containerRenderers = [
      ..._MarkdownRenderer.defaultContainerRenderers,
      ...containerRenderers
    ].map((rfn) => rfn.bind(this));
  }
  // eslint-disable-next-line complexity
  renderContainer(caller) {
    let rendered = "";
    if (!caller) {
      throw new Error("provide caller token");
    }
    if (!this.containers.length) {
      return rendered;
    }
    for (let i = 0; i < this.containers.length; i++) {
      const container = this.containers[i];
      const previous = this.containers[i - 1];
      if (i && sameRow(previous, container) && aligned(previous, container)) {
        const lspaces2 = Math.max(container.lspaces - previous.tspaces, 0);
        this.containers[i].lspaces = lspaces2;
      }
      const lspaces = this.containers[i].lspaces;
      rendered += this.SPACE.repeat(lspaces);
      for (const renderer of this.containerRenderers) {
        const rv = renderer(this.containers, i, caller);
        if (rv == null ? void 0 : rv.length) {
          rendered += rv;
          break;
        }
      }
      this.containers[i].rendered = true;
    }
    return rendered;
  }
};
var MarkdownRenderer = _MarkdownRenderer;
MarkdownRenderer.defaultRules = { ...inline, ...block, ...diplodoc };
MarkdownRenderer.defaultHandlers = { ...diplodoc2 };
MarkdownRenderer.defaultHooks = { ...diplodoc3 };
MarkdownRenderer.defaultContainerRenderers = [
  renderEmptyBlockquote,
  renderEmptyListItem,
  renderOrderedList,
  renderUnorderedList,
  renderBlockquote
];

// src/plugin/index.ts
var always5 = (v) => () => v;
var id = (a) => a;
function mdRenderer(parser, parameters) {
  parser.inline.ruler.at("escape", always5(false));
  parser.inline.ruler.at("entity", always5(false));
  parser.normalizeLink = id;
  const options = {
    ...parameters
  };
  const renderer = new MarkdownRenderer(options);
  parser.renderer = renderer;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MarkdownRenderer,
  MarkdownRendererLifeCycle,
  MarkdownRendererMode,
  mdRenderer
});
